import API from "../lib/api";

export const getReceiptSettingsApi = async (restaurantId) => {
  try {
    const response = await API.get(`/restaurant/${restaurantId}/receipt-settings`);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};

export const updateReceiptSettingsApi = async (restaurantId, data) => {
  try {
    const response = await API.put(`/restaurant/${restaurantId}/receipt-settings`, data);
    return response.data;
  } catch (error) {
    return (
      error.response?.data || {
        status: "failure",
        message: "Something went wrong.",
      }
    );
  }
};
